module.exports = __webpack_public_path__ + "static/media/iconCanvas03.777e4c64.svg";